<vl-popover label-close-aria="Sluiten" mod-left mod-large>
    <template v-slot:label>
        <vl-icon icon="question-mark"/>
    </template>
    <vl-typography>
        De status van een sessie kan één van de volgende waarden aannemen:
        <ul>
            <li><strong>Pending</strong>: de sessie is aangemaakt en doorgestuurd naar Athumi Account, maar de betaling is nog niet gestart.</li>
            <li><strong>Submitted</strong>: de betaling is gestart en doorgestuurd voor verwerking, naar de PSP of als service-saldotransactie.</li>
            <li><strong>PaymentSuccessful</strong>: de betaling bij de PSP is geslaagd, maar wordt nog verwerkt in Business Central.</li>
            <li><strong>PaymentUnSuccessful</strong>: de betaling bij de PSP is mislukt.</li>
            <li><strong>Completed</strong>: de betaling is volledig verwerkt en afgerond.</li>
            <li><strong>Cancelled</strong>: de gebruiker heeft de betaling geannuleerd voordat deze werd afgerond.</li>
            <li><strong>Expired</strong>: de sessie is verlopen omdat de betaling niet binnen de voorziene tijd werd afgerond.</li>
        </ul>
    </vl-typography>
</vl-popover>
